import { useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobPauseState } from "@/types";

const PAUSE_STATE_STALE_MS = 30_000;

export const jobPauseStateQueryKey = (jobId: string) =>
  ["job-pause-state", jobId] as const;

/**
 * Reads a job's pause flags on demand rather than on render — the move gate
 * only needs them at the moment a candidacy is being moved. Cached briefly so a
 * run of moves on one job costs a single request.
 */
export function useFetchJobPauseState() {
  const queryClient = useQueryClient();

  return async (jobId: string) =>
    queryClient.fetchQuery({
      queryKey: jobPauseStateQueryKey(jobId),
      staleTime: PAUSE_STATE_STALE_MS,
      queryFn: async () => {
        // Null when the job is gone — guac's findPauseState is a findUnique.
        const res = await guacHttpClient.get<
          JobPauseState | null,
          HttpResponse<JobPauseState | null>
        >(`jobs/${jobId}/pause-state`);

        return res.data;
      },
    });
}
